import { ChainID } from '@ankr.com/chains-list';

const beacons: ChainID[] = [
  ChainID.ETH_BEACON,
  ChainID.ETH_SEPOLIA_BEACON,
  ChainID.ETH_HOLESKY_BEACON,
  ChainID.GNOSIS_BEACON,
  ChainID.GNOSIS_TESTNET_BEACON,
  ChainID.ETH_HOODI_BEACON,
];

export const isBeacon = (chainID: ChainID | undefined) =>
  !!chainID && beacons.includes(chainID);
